import axios from './axios'

export default {
  fetchFrequentlyAskedQuestion: (url) => {
    return axios.get(`api/widget/faqs/${url}`, {
      headers: {
        'user_token': localStorage.user
      },
    })
  },
  sendView: data => {
    return axios.post(`api/widget/views/`, data, {
      headers: {
        'user_token': localStorage.user
      },
    })
  },
  checkShowRaiting: (id) => axios.get(
    `api/widget/ratings/faqs/${id}`, {
    headers: {
      'user_token': localStorage.user
    },
  }
  ),
  postData: (url, data) => axios.post(url, data, {
    headers: {
      'user_token': localStorage.user
    },
  }),
  fetchData: url => axios.get(url, {
    headers: {
      'user_token': localStorage.user
    },
  }),
  sendFiles: data => axios.post('api/widget/faqs/', data, {
    headers: {
      'user_token': localStorage.user
    },
  }),
  downloadFile: (url) => axios({ url, method: 'GET', responseType: 'blob', }),
  getParamsWidget: widgetId => axios.get(`/api/v2/widgets/${widgetId}`),
  getHistory: dialogId => axios.get(`api/v2/dialogs/${dialogId}`),
  sendMessageOpenWidgetToNodered: payload => axios.post('api/bots/askme/widget/open', payload),
  sendMessageCloseWidgetToNodered: payload => axios.post('api/bots/askme/close/dialogue', payload),
  sendTokenAfterAuth: payload => axios.post('api/bots/session/add/auth', payload),
  sendNoderedStatusWidget: payload => axios.post('api/bots/askme/widgetstate/dialogue', payload),

}